/* eslint-disable import/no-anonymous-default-export */
import { Button, Form, Input, InputNumber, Select } from "antd";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import styled from "styled-components";
import DataSave from "../common/components/DataSave";
import MainLayout from "../common/components/MainLayout";
import { ActionResult } from "../common/hooks/useApi";
import useUnidadesProduccionAPI, { UnidadProduccion } from "../unidades-produccion/useUnidadesProduccionAPI";
import useAgentesAPI, { Agente } from "./useAgentesAPI";


const Firma = styled.img`
display:block;
width:auto;
height:80px;
margin-bottom:0.5rem;
`;

const toBase64 = (file: File): Promise<string | undefined> => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result?.toString());
    reader.onerror = error => reject(error);
});

export default () => {
    const { id } = useParams();
    const api = useAgentesAPI();
    const unidadesProduccionApi = useUnidadesProduccionAPI();
    const successRoute = "/agentes";
    const [firma, setFirma] = useState<string>();
    const [unidadesProduccionResponse, setUnidadesProduccionResponse] = useState<ActionResult<UnidadProduccion[]>>();

    const loadSignature = async () => {
        const input = document.createElement("input");
        input.type = "file";
        input.onchange = async (e: any) => {
            const file = e.target.files.item(0) as File;
            setFirma(await toBase64(file));
        };
        input.click();
    };

    useEffect(() => {
        unidadesProduccionApi
            .list({})
            .then(setUnidadesProduccionResponse)
    }, []);

    return (
        <MainLayout title="Guardar agente">
            <DataSave<Agente, Partial<Agente>, Agente>
                list={api.list}
                save={api.save}
                onLoadedItem={async (item, formItem) => setFirma(item.Firma)}
                transformOnLoad={async (value) => value}
                transformOnSave={async (value) => ({ ...value, ...{ Firma: firma } })}
                id={id}
                successRoute={successRoute}
            >
                <Form.Item
                    rules={[
                        { required: true, message: "Campo requerido" }
                    ]}
                    required
                    name={"Nombre"}
                    label="Nombre">
                    <Input />
                </Form.Item>

                <Form.Item
                    rules={[
                        { required: true, message: "Campo requerido" }
                    ]}
                    required
                    name={"Apellido"}
                    label="Apellido">
                    <Input />
                </Form.Item>

                <Form.Item >
                    {firma && <Firma src={firma} />}
                    <Button onClick={loadSignature}>Cargar firma</Button>
                    <Input hidden readOnly />
                </Form.Item>

                <Form.Item
                    rules={[
                        { required: true, message: "Campo requerido" }
                    ]}
                    required
                    name={"Cargo"}
                    label="Cargo">
                    <Input />
                </Form.Item>

                <Form.Item
                    rules={[
                        { required: true, message: "Campo requerido" }
                    ]}
                    required
                    name={"Dni"}
                    label="DNI">
                    <Input />
                </Form.Item>

                <Form.Item
                    rules={[
                        { required: true, message: "Campo requerido" }
                    ]}
                    required
                    name={"Matricula"}
                    label="Matricula/Legajo">
                    <Input />
                </Form.Item>

                <Form.Item
                    help={"¿A que unidad de producción pertenece el agente?"}
                    name={"UnidadProduccionAgenteId"}
                    label="Unidad de producción">
                    <Select
                        value
                        showSearch
                        optionFilterProp="children"
                        loading={!unidadesProduccionResponse}>
                        {unidadesProduccionResponse?.data?.value.map(u =>
                            <Select.Option value={u.Id}>{u.Nombre}</Select.Option>)}
                    </Select>
                </Form.Item>

            </DataSave>
        </MainLayout>
    );
};